import {Flex, Grid, Image, View} from '@aws-amplify/ui-react';
import {Link, useLoaderData, useNavigation} from "react-router-dom";
import img1 from '../../assets/images/01-video.png';
import img2 from '../../assets/images/02-magazine.png';
import img3 from '../../assets/images/03-for-kids.png';
import img4 from '../../assets/images/04-webinar.png';
import styles from './index.module.css'
import GlobalAlert from '../../components/GlobalAlert';
import React from "react";
import Loading from "../../components/Loading";

export default function Home() {
  const {
    courses = [],
    error,
  } = useLoaderData();

  const getCourseImage = courseId => {
    switch (courseId) {
      case 3199:
        return img1;
      case 3200:
        return img2;
      case 3201:
        return img3;
      default:
        return img4;
    }
  }

  const navigation = useNavigation();

  if (navigation.state === "loading") {
    return <Loading/>
  }

  courses.sort((a, b) => {
    return a.order - b.order;
  });

  return (
    <View>
      {
        !!error &&
        <GlobalAlert
          variation="error"
          heading={error.toString()}
        />
      }
      <Grid
        minHeight="calc(100vh - 186px)"
        templateColumns={{base: "1fr", medium: "1fr 1fr", large: "1fr 1fr 1fr 1fr"}}
        templateRows={{base: "repeat(3, auto)", medium: "auto"}}
      >
        {
          courses.length > 0 &&
          (
            courses.map(course => {
              const {
                id = 0,
                title = "",
              } = course || {};

              return (
                <Flex
                  key={id}
                >
                  <Link
                    to={`/corsi/${id}`}
                    className={styles.courseLink}
                  >
                    <Image
                      src={getCourseImage(id)}
                      alt={title}
                      className={styles.courseImg}
                    />
                  </Link>
                </Flex>
              );
            })
          )
        }
      </Grid>
    </View>
  );
}